import View from './view.js';
import icons from 'url:../../img/icons.svg';
import { Fraction } from 'fractional';

class RecipeView extends View {
  _parentElement = document.querySelector(`.recipe`);
  _errorMessage = `We could not find this recipe. Please try anothewr one.`;
  _message = ``;

  addHandlerRender = function (handler) {
    [`load`, `hashchange`].forEach(el => window.addEventListener(el, handler));
  };

  addHandlerServings = function (handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const button = e.target.closest(`.btn--tiny`);
      if (!button) return;
      const updateTo = +button.dataset.updateTo;
      handler(updateTo);
    });
  };

  addHandlerAddBookmark = function (handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--add-bookmark`);
      if (!btn) return;
      handler();
    });
  };

  addHandlerAddShoppingList = function (handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--add-shoplist`);
      if (!btn) return;
      handler();
    });
  };

  _generateMarkup = function () {
    return `
    <figure class="recipe__fig">
          <img src="${this._data.imageUrl}" alt="${
      this._data.title
    }" class="recipe__img" />
          <h1 class="recipe__title">
            <span>${this._data.title}</span>
          </h1>
        </figure>

        <div class="recipe__details">
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${icons}#icon-clock"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--minutes">${
              this._data.cookingTime
            }</span>
            <span class="recipe__info-text">minutes</span>
          </div>
          <div class="recipe__info">
            <svg class="recipe__info-icon">
              <use href="${icons}#icon-users"></use>
            </svg>
            <span class="recipe__info-data recipe__info-data--people">${
              this._data.servings
            }</span>
            <span class="recipe__info-text">servings</span>

            <div class="recipe__info-buttons">
              <button data-update-to=${
                this._data.servings - 1
              } class="btn--tiny btn--increase-servings">
                <svg>
                  <use href="${icons}#icon-minus-circle"></use>
                </svg>
              </button>
              <button data-update-to=${
                this._data.servings + 1
              } class="btn--tiny btn--increase-servings">
                <svg>
                  <use href="${icons}#icon-plus-circle"></use>
                </svg>
              </button>
            </div>
          </div>

          
          <button class="btn--round btn--add-bookmark">
            <svg class="">
              <use href="${icons}#icon-bookmark${
      this._data.bookmarked ? `-fill` : ``
    }"></use>
            </svg>
          </button>
          <button class="btn--round btn--add-shoplist">
            <svg class="">
              <use href="${icons}#icon-${
      this._data.shoppingListed ? `minus` : `plus`
    }-circle"></use>
            </svg>
          </button>
        </div>

        <div class="recipe__ingredients">
          <h2 class="heading--2">Recipe ingredients</h2>
          <ul class="recipe__ingredient-list">
            ${this._generateIngredientMarkup()}
          </ul>
        </div>

        <div class="recipe__directions">
          <h2 class="heading--2">How to cook it</h2>
          <p class="recipe__directions-text">
            This recipe was carefully designed and tested by
            <span class="recipe__publisher">The Pioneer Woman</span>. Please
            check out directions at their website.
          </p>
          <a
            class="btn--small recipe__btn"
            href="http://thepioneerwoman.com/cooking/pasta-with-tomato-cream-sauce/"
            target="_blank"
          >
            <span>Directions</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </a>
        </div>
    `;
  };

  _generateIngredientMarkup = function () {
    return this._data.ingredients
      .map(ing => {
        return `
      <li class="recipe__ingredient">
              <svg class="recipe__icon">
                <use href="${icons}#icon-check"></use>
              </svg>
              <div class="recipe__quantity">${
                ing.quantity ? new Fraction(ing.quantity).toString() : ``
              }</div>
              <div class="recipe__description">
                <span class="recipe__unit">${ing.unit}</span>
                ${ing.description}
              </div>
            </li>
      `;
      })
      .join(``);
  };
}

export default new RecipeView();
